import { render } from "./ButtonStart.vue?vue&type=template&id=37bd9e56&scoped=true"
import script from "./ButtonStart.vue?vue&type=script&lang=js"
export * from "./ButtonStart.vue?vue&type=script&lang=js"

import "./ButtonStart.vue?vue&type=style&index=0&id=37bd9e56&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37bd9e56"

export default script